import React from 'react';
import styled from 'styled-components';
import { StateButton, StateButtonProps } from '~common/components/button/state-button.component';
import { PlusIcon } from '~web/view/components/ui/icon/plus.icon';

export const AddButton: React.FunctionComponent<StateButtonProps> = ({ ...rest }) => (
  <StyledStateButton {...rest}>
    <PlusIcon width={12} height={18} />
  </StyledStateButton>
);

const StyledStateButton = styled(StateButton)`
  && {
    min-width: 54px;
    width: 54px;
    height: 54px;
    padding: 0;
  }
`;



// WEBPACK FOOTER //
// ./view/components/ui/button/add-button.component.tsx